import { format, parse, set } from "date-fns";
import { useMemo } from "react";

import { DATE_FORMAT, DATE_TIME_FORMAT } from "../components/calendar/calendar.constants";
import { useAppointmentStore } from "../store/appointment/appointment-store";

export function useSelectedDate() {
  const {
    appointmentData: { date, timeRange },
  } = useAppointmentStore();

  return useMemo(() => {
    const createDateFromTimeString = (time: string) => {
      if (!date)
        return new Date();

      if (!time) {
        return parse(date, "yyyy-MM-dd", new Date());
      }

      const parsedDate = parse(date, DATE_FORMAT, new Date());
      const [hours, minutes] = time.split(":").map(Number);

      return set(parsedDate, {
        hours,
        minutes,
        seconds: 0,
      });
    };

    const fromObj = createDateFromTimeString(timeRange[0]);
    const toObj = createDateFromTimeString(timeRange[1]);

    const fromFormatted = format(fromObj, DATE_TIME_FORMAT);
    const toFormatted = format(toObj, DATE_TIME_FORMAT);

    return {
      fromObj,
      toObj,
      fromFormatted,
      toFormatted,
    };
  }, [date, timeRange]);
}
